<template>
    <div class="d-flex">
        <DInput
            id="location"
            v-model="selectedValue"
            readonly
        />
        <DButton
            id="open-location-modal"
            :label="__('contracts.fulfillment.herold_at.choose')"
            color="primary"
            class="ms-3"
            @click="openModal"
        />
    </div>

    <HeroldAtLocationModal
        :value="value"
        :show-modal="showModal"
        @update:modelValue="updateValue"
        @close-modal="closeModal"
    />
</template>

<script setup>
import HeroldAtLocationModal from '~@/Components/Fulfillment/Options/HeroldAtLocationModal'
import { ref } from 'vue'

const emit = defineEmits(['update:modelValue'])

const props = defineProps({
    value: {
        default: null,
        type: Number
    },
    displayValue: {
        default: null,
        type: [String, Number]
    }
})

const showModal = ref(false)

function openModal () {
    showModal.value = true
}

function closeModal () {
    showModal.value = false
}

const selectedValue = ref(props.displayValue)

function updateValue (value) {
    if (typeof value === 'object') {
        selectedValue.value = value.display_value
    } else {
        selectedValue.value = value
    }
    emit('update:modelValue', value)
    showModal.value = false
}
</script>
